import { useEffect, useState } from 'react';
import { Button, Select } from 'components/common';

export interface Team {
  label: string;
  value: number;
}

interface TeamSelectFormProps {
  availableTeams: Team[];
  cancelLabel: string;
  disabled?: boolean;
  onCancel: () => void;
  onSubmit: (team: Team) => void;
  resetKey?: unknown;
  selectTestId?: string;
  submitTestId?: string;
  cancelTestId?: string;
}

type SelectedValue = Team | Team[] | string | null;

const isTeam = (value: SelectedValue): value is Team =>
  value !== null && !Array.isArray(value) && typeof value !== 'string' && typeof value.value === 'number';

const TeamSelectForm = ({
  availableTeams,
  cancelLabel,
  disabled = false,
  onCancel,
  onSubmit,
  resetKey = null,
  selectTestId,
  submitTestId,
  cancelTestId,
}: TeamSelectFormProps) => {
  const [selectedTeam, setSelectedTeam] = useState<Team | null>(null);

  const handleChange = (team: SelectedValue) => {
    setSelectedTeam(isTeam(team) ? team : null);
  };

  useEffect(() => {
    setSelectedTeam(null);
  }, [resetKey]);

  return (
    <>
      <div className="mb-3">
        <label className="fw-bold" htmlFor="teams">
          Teams*
        </label>
        <Select
          autoFocus
          className="form-react-select"
          clearValue={null}
          inputId="teams"
          onChange={handleChange}
          options={availableTeams}
          placeholder="Select one"
          selected={selectedTeam}
          testId={selectTestId}
        />
      </div>
      <div className="d-flex gap-2">
        <Button
          disabled={!selectedTeam || disabled}
          onClick={() => selectedTeam && onSubmit(selectedTeam)}
          testId={submitTestId}
          text="bold"
          variant="primary-dark"
        >
          Send request
        </Button>
        <Button disabled={disabled} onClick={onCancel} testId={cancelTestId} text="bold" variant="border">
          {cancelLabel}
        </Button>
      </div>
    </>
  );
};

export default TeamSelectForm;
